
<form [formGroup]="form">
  @if (sectionContainerType === ESectionContainerType.ACTIVITY) {
    @switch (section?.type_id) {
      @case (ESectionType.ACTIVITY_TIPS) {
        <app-activity-tips-section formControlName="data"></app-activity-tips-section>
      }
      @case (ESectionType.ACTIVITY_VARIATIONS) {
        <app-activity-variations-section formControlName="data"></app-activity-variations-section>
      }
      @case (ESectionType.ACTIVITY_WHAT) {
        <app-activity-what-section formControlName="data"></app-activity-what-section>
      }
      @case (ESectionType.GLOSSARY) {
        <app-glossary-section formControlName="data" ></app-glossary-section>
      }
      @case (ESectionType.REQUIRED_MATERIAL) {
        <app-required-material-section formControlName="data"></app-required-material-section>
      }
      @case (ESectionType.SOURCES) {
        <app-sources-section formControlName="data"></app-sources-section>
      }
      @case (ESectionType.YOUTUBE) {
        <app-youtube-section formControlName="data"></app-youtube-section>
      }
      @case (ESectionType.MEDIA) {
        <app-image-section  formControlName="data" [uploadData]="uploadData" [identifier]="section.id.toString()" purpose="activity" (changedSection)="save(true)"></app-image-section>
        <app-select-media [uploadData]="uploadData" (selected)="addImage($event)" [identifier]="section.id.toString()" [disabled]="( allowedToEdit$ | async ) === false"></app-select-media>
      }
      @case (ESectionType.MATERIAL) {
        <app-activity-material-section formControlName="data"></app-activity-material-section>
      }
      @case (ESectionType.SMALLSTEPS_PREPARATION) {
        <app-smallsteps-preparation formControlName="data"></app-smallsteps-preparation>
      }
      @case (ESectionType.SMALLSTEPS_INTRODUCTION) {
        <app-smallsteps-introduction formControlName="data"></app-smallsteps-introduction>
      }
      @case (ESectionType.SMALLSTEPS_INSTRUCTION) {
        <app-smallsteps-instruction formControlName="data"></app-smallsteps-instruction>
      }
      @case (ESectionType.SMALLSTEPS_CONCLUSION) {
        <app-smallsteps-conclusion formControlName="data"></app-smallsteps-conclusion>
      }
    }
  }

  @if (sectionContainerType === ESectionContainerType.PROGRAM_PERIOD) {
    @switch (section?.type_id) {
      @case (EProgramPeriodSectionType.ACTIVITY) {
        <app-period-activity-section
          formControlName="data"
          (selected)="addActivityImage($event)"
          (uploaded)="addActivityImage($event)"
          [sectionId]="section.id"
        ></app-period-activity-section>
      }
      @case (EProgramPeriodSectionType.MEDIA) {
        <app-image-section  formControlName="data" [uploadData]="uploadData" [purpose]="mediaPurpose" [identifier]="section.id.toString()" (changedSection)="save(true)"></app-image-section>
        @if (!readOnly) {
          <div class="period-media-actions period-media-actions--inline">
            <div class="period-media-actions__left">
              <app-select-media
                [uploadData]="uploadData"
                (selected)="addImage($event)"
                [identifier]="section.id.toString()"
                [purpose]="mediaPurpose"
              ></app-select-media>
            </div>
            <div class="period-media-actions__right">
              @if (canRemoveLastSectionOfType) {
                <button
                  (click)="remove()"
                  mat-stroked-button
                  color="warn"
                  type="button"
                  >
                  {{ 'section.remove' | translate: {sectionDisplayName} }}
                </button>
              }
              <button
                (click)="save()"
                mat-flat-button
                color="primary"
                type="button"
                >
                {{ 'generic.save' | translate }}
              </button>
            </div>
          </div>
        }
      }
      @case (EProgramPeriodSectionType.ACTIVITY_WHAT) {
        <app-activity-what-section formControlName="data"></app-activity-what-section>
      }
      @case (EProgramPeriodSectionType.BANNER) {
        <app-image-section
          formControlName="data"
          [uploadData]="uploadData"
          [purpose]="mediaPurpose"
          [identifier]="section.id.toString()"
          [maxMediaItems]="1"
          (changedSection)="save(true)"
        ></app-image-section>
        @if (!readOnly) {
          <div class="period-media-actions period-media-actions--inline">
            <div class="period-media-actions__left">
              <app-select-media
                [uploadData]="uploadData"
                (selected)="addImage($event)"
                [identifier]="section.id.toString()"
                [purpose]="mediaPurpose"
              ></app-select-media>
            </div>
            <div class="period-media-actions__right">
              @if (canRemoveLastSectionOfType) {
                <button
                  (click)="remove()"
                  mat-stroked-button
                  color="warn"
                  type="button"
                  >
                  {{ 'section.remove' | translate: {sectionDisplayName} }}
                </button>
              }
              <button
                (click)="save()"
                mat-flat-button
                color="primary"
                type="button"
                >
                {{ 'generic.save' | translate }}
              </button>
            </div>
          </div>
        }
      }
    }
  }

  @if (shouldShowColumnsSelector()) {
    <div
      class="columns-selector"
      >
      <mat-radio-group formControlName="columns">
        @for (columnCount of [1, 2, 3, 4]; track columnCount) {
          <mat-radio-button [value]="columnCount">
            {{ 'section.column_count' | translate: {columnCount} }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  }
</form>
@if (!isProgramPeriodMediaLikeSection()) {
  <div class="activity-button-section">
    @if (sectionContainerType === ESectionContainerType.ACTIVITY && sectionTypesWithUserConfigurableInputCount.includes(section?.type_id)) {
      <button
        (click)="addControl()"
        mat-button
        type="button"
        >
        {{ 'section.' + getNameForSectionType(section.type_id) + '.add_input' | translate }}
      </button>
    }
    @if (canRemoveLastSectionOfType && !readOnly) {
      <button
        (click)="remove()"
        mat-button
        type="button"
        [disabled]="sectionContainerType === ESectionContainerType.ACTIVITY && ( allowedToEdit$ | async ) === false"
        >
        {{ 'section.remove' | translate: {sectionDisplayName} }}
      </button>
    }
    @if (( section?.type_id !== ESectionType.PAGE_END ) && !readOnly) {
      <button
        (click)="save()"
        mat-button
        type="button"
        [disabled]="sectionContainerType === ESectionContainerType.ACTIVITY && ( allowedToEdit$ | async ) === false"
        >
        {{ 'generic.save' | translate }}
      </button>
    }
  </div>
}
